// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__SKodn","sectionNotFound":"NotFound_sectionNotFound__Jh3a-","p404":"NotFound_p404__Tw6f5","titleNotFound":"NotFound_titleNotFound__gy6a9"};